import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 150);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative min-h-screen w-full flex flex-col items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=professional%20cleaning%20staff%20team%20smiling%20uniformed%20cleaners%20holding%20mops%20brooms%20cleaning%20supplies%20bright%20modern%20home%20interior%20happy%20workers%20residential%20cleaning%20service%20team%20photo%20wide%20angle%20photorealistic&width=1920&height=1080&seq=chcc-staff-bg-009&orientation=landscape)',
        }}
      />
      {/* Light blue overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-sky-700/70 via-sky-600/60 to-sky-800/75" />

      {/* Content */}
      <div
        className={`relative z-10 w-full flex flex-col items-center justify-center px-6 py-20 text-center transition-all duration-1000 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        {/* Logo */}
        <div className="mb-10">
          <img
            src="https://static.readdy.ai/image/e50d925263add9c47b947a5709171c8c/9a6bdf426d6b6d9e6d51bd187be39caf.png"
            alt="Complete HomeCare Cleaning"
            className="h-56 w-auto object-contain mx-auto drop-shadow-2xl"
          />
        </div>

        {/* Main headline */}
        <h1 className="text-7xl md:text-9xl font-extrabold text-white mb-6 tracking-tight leading-none drop-shadow-lg">
          Under
          <br />
          <span className="text-sky-300">Construction</span>
        </h1>

        {/* Subtext */}
        <p className="text-white/70 text-lg md:text-xl max-w-lg mx-auto mb-10 leading-relaxed">
          We&apos;re building something great. In the meantime, we&apos;re fully
          available for bookings and inquiries.
        </p>

        {/* Available badge */}
        <div className="mb-10">
          <span className="inline-flex items-center gap-2 bg-emerald-500/20 border border-emerald-400/50 text-emerald-300 text-sm font-semibold px-5 py-2 rounded-full backdrop-blur-sm">
            <i className="ri-checkbox-circle-fill text-emerald-400" />
            Now Available for Booking
          </span>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 items-center justify-center">
          <a
            href="tel:+17076236359"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-sky-500 hover:bg-sky-400 text-white font-semibold px-10 py-4 rounded-md transition-all duration-200 text-base tracking-wide shadow-lg hover:shadow-sky-500/40 cursor-pointer"
          >
            <i className="ri-phone-fill" />
            Call Now
          </a>
          <a
            href="https://wa.me/17076236359"
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-white font-semibold px-10 py-4 rounded-md transition-all duration-200 text-base tracking-wide shadow-lg hover:shadow-emerald-500/40 cursor-pointer"
          >
            <i className="ri-whatsapp-line" />
            WhatsApp
          </a>
        </div>

        {/* Phone number display */}
        <p className="mt-6 text-white/50 text-sm tracking-widest">
          +1 (707) 623-6359
        </p>
      </div>
    </section>
  );
}
